export const setScrollTop = (iframe: HTMLIFrameElement, scrollTop: number): void => {
  iframe.contentWindow!.scrollTo(0, scrollTop);
};
